<div class="mct-flex mct-col mct-gap-8"   *ngIf="openFieldData">
  <div>
    <label>
      {{ openFieldData.Required && openFieldData.Label ? '*' : '' }}
      {{ openFieldData.Label }}
    </label>
  </div>
  <div [ngSwitch]="openFieldData.OpenFieldType">
    <input *ngSwitchCase="openFieldType.Textbox" class="form-control" />
    <p-select
      *ngSwitchCase="openFieldType.Dropdown"
      appendTo="body"
      [options]="openFieldData.Options"
      [style]="{ width: '100%' }"
      [placeholder]="'common.select-one' | translate | ucfirst"
    ></p-select>
    <div class="mct-flex mct-col mct-gap-5" *ngSwitchCase="openFieldType.CheckboxList"  >
      <label *ngIf="openFieldData.Required && openFieldData.Options.length > 1">
        {{ openFieldData.Required && !openFieldData.Label ? '*' : '' }}
        {{ 'form-builder.legos.open-field.select-at-least-one' | translate | ucfirst }}
      </label>
      <div *ngFor="let option of openFieldData.Options; let i = index">
        <p-checkbox [binary]="true" [inputId]="'openFieldOption' + i"> </p-checkbox>
        <label [for]="'openFieldOption' + i">
          {{ option }}
        </label>
      </div>
    </div>
  </div>
</div>
